import { call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { signalingScreenshareWhiteboardLaserUpdated } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* onScreenshareWhiteboardLaserUpdatedSaga(
  action: ReturnType<typeof signalingScreenshareWhiteboardLaserUpdated>
) {
  const { feedId, userId, data } = action.payload;

  if (contentBoard.type !== 'screenshare' || contentBoard.id !== feedId) {
    return;
  }

  try {
    const parsedData = JSON.parse(data);

    yield call(contentBoard.updateRemoteLaserPointer, {
      id: feedId,
      userId,
      page: 0,
      data: parsedData,
    });
  } catch (error) {
    Sentry.captureException(error);
  }
}
